<!-- Header -->
<div class="flex justify-between items-center">
  <h3 class="text-lg font-bold">
    @if(isEditMode) { Edit Custodian Info } @else { Add Custodian Info }
  </h3>
  <button mat-dialog-close class="self-start">
    <img
      class="my-0"
      width="16"
      height="16"
      alt="Close"
      src="assets/icons/close.svg"
    />
  </button>
</div>

<!-- Body  -->
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
  <!-- Name -->
  <et-atoms-input>
    <label>Custodian Name</label>
    <input
      etAtomsInput
      formControlName="eJournalCustodianName"
      type="text"
      required
    />
    @if(form.controls.eJournalCustodianName.touched &&
    form.controls.eJournalCustodianName.hasError('required')) {
    <span etAtomsInputError>Custodian name is required</span>
    }
  </et-atoms-input>

  <!-- Email -->
  <et-atoms-input>
    <label>Custodian Email</label>
    <input
      etAtomsInput
      formControlName="eJournalCustodianEmail"
      type="email"
      required
    />

    @if(form.controls.eJournalCustodianEmail.touched &&
    form.controls.eJournalCustodianEmail.hasError('required')) {
    <span etAtomsInputError>Custodian email is required</span>
    } @if(form.controls.eJournalCustodianEmail.touched &&
    form.controls.eJournalCustodianEmail.hasError('email')) {
    <span etAtomsInputError>Custodian email is invalid</span>
    }
  </et-atoms-input>

  <!-- Buttons -->
  <div class="flex justify-center gap-6">
    <button
      mat-dialog-close
      type="button"
      class="btn btn-outline normal-case rounded-full min-w-[124px] text-base h-10 min-h-[40px]"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary normal-case rounded-full min-w-[124px] text-base h-10 min-h-[40px]"
      [class.pointer-events-none]="isSubmitting()"
    >
      @if(isSubmitting()) {
      <et-atoms-spinner size="small"></et-atoms-spinner>
      } @else { @if(isEditMode) { Update } @else { Add } }
    </button>
  </div>
</form>
